import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LoaderButton, IconLabel } from 'ctia-ui';
import { approveRequest, withdrawRequest } from 'actions/request';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { fetchApproveWaitingRequests, clearRequests } from 'actions/requests';
import { showNotice } from 'actions/notifier';
import { notifyMessages } from 'helpers/NotifyHelper';
import { isCTIAUser } from 'helpers/Users';
import ModalConfirm from 'components/ModalConfirm';

class ApproveButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showWithdrawnConfirm: false,
      showApproveConfirm: false,
      isLoading: false,
      isFormValid: true
    };
  }

  onApprove = () => {
    this.setState({ isLoading: true });
    const {
      startPreloader,
      finishPreloader,
      approveRequest,
      fetchApproveWaitingRequests,
      showNotice,
      request,
      withdraw = false
    } = this.props;

    const approved = !withdraw;

    const message = approved
      ? notifyMessages.requestApprovedSuccessfully
      : notifyMessages.requestWithdrawnSuccessfully;

    startPreloader();
    approveRequest(request.id, approved)
      .then(fetchApproveWaitingRequests)
      .then(() => this.closeModal)
      .then(() => showNotice(message))
      .then(finishPreloader);
  };

  onWithdraw = () => {
    const id = this.props.id;

    // withdraw reason
    const reason = document.getElementById('reasonRef').value;

    if (reason.length < 5) {
      this.setState({ isFormValid: false });
    } else {
      this.setState({ isLoading: true });
      this.props
        .withdrawRequest(id, reason)
        .then(this.clearAndFetch)
        .then(
          this.props.showNotice(notifyMessages.requestWithdrawnSuccessfully)
        )
        .catch(() => this.props.showNotice(notifyMessages.cantWithdrawRequest));
    }
  };

  clearAndFetch = () => {
    this.props.clearRequests();
    this.props.fetchApproveWaitingRequests();
  };

  showWithdrawnModal = () => this.setState({ showWithdrawnConfirm: true });
  showApproveModal = () => this.setState({ showApproveConfirm: true });

  closeModal = () => {
    this.setState({
      showWithdrawnConfirm: false,
      showApproveConfirm: false,
      isLoading: false
    });
  };

  getStyleParams = withdraw => {
    return {
      btnStyle: withdraw ? 'danger' : 'success',
      btnText: withdraw ? 'Withdraw' : 'Approve',
      approved: !withdraw
    };
  };

  render() {
    const { withdraw = false, request, user } = this.props;

    // don't show approve button for CTIA Staff
    if (isCTIAUser(user) && !withdraw) return null;

    // don't show withdraw button for CBRS Staff
    if (!isCTIAUser(user) && withdraw) return null;

    const params = this.getStyleParams(withdraw);
    const modalHandler = withdraw
      ? this.showWithdrawnModal
      : this.showApproveModal;

    const renderButtonIcon = () => {
      const icon = withdraw ? 'ban' : 'check';
      return <IconLabel label={params.btnText} awesomeIcon={icon} />;
    };

    return [
      <LoaderButton
        bsStyle={params.btnStyle}
        bsSize="xsmall"
        text={renderButtonIcon()}
        style={{ marginRight: 15 }}
        onClick={modalHandler}
        key={1}
      />,
      <ModalConfirm
        type="withdrawReason"
        show={this.state.showWithdrawnConfirm}
        onHide={this.closeModal}
        onHandle={this.onWithdraw}
        requestData={request}
        isLoading={this.state.isLoading}
        isFormValid={this.state.isFormValid}
        key={2}
      />,
      <ModalConfirm
        type="approve"
        show={this.state.showApproveConfirm}
        onHide={this.closeModal}
        onHandle={this.onApprove}
        requestData={request}
        isLoading={this.state.isLoading}
        key={3}
      />
    ];
  }
}

function mapStateToProps({ user }) {
  return { user };
}

export default connect(
  mapStateToProps,
  {
    approveRequest,
    withdrawRequest,
    startPreloader,
    finishPreloader,
    fetchApproveWaitingRequests,
    showNotice,
    clearRequests
  }
)(ApproveButton);



// WEBPACK FOOTER //
// ./src/components/request/ApproveButton.js